<template>
    <span>{{ this.preOutput}} {{ this.output}}</span>
</template>

<script>

import {countdownBehavior} from '@/mixins/countdownBehavior'
export default {
    name:'RTCountdown',
    mixins:[countdownBehavior],
    props:{
       
    },
    data() {
        return {
            
        }
    },
    computed: {

        output(){
            var res="";
            res+=(this.years>0)?this.years + "y ":"";
            res+=(this.months>0)?this.months + "m ":"";
            res+=(this.days>0)?this.days + "d ":"";
            res+=(this.hours>0)?this.hours + "h ":"";
            res+=(this.minutes>0)?this.minutes + "m ":"";
            res+=this.seconds + "s "
            return res;
        },
    },
    methods:{
    },

    mounted(){
        this.startCountdown();
    },
}
</script>

<style scoped>
.progress{
    font-size: small;
    height:18px;
}

</style>